"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const chunk_1 = __importDefault(require("lodash/chunk"));
const NekostoreError_1 = __importDefault(require("../../../NekostoreError"));
function getCollection(driver, path) {
    const paths = path.split(/\//g);
    if (paths.length % 2 !== 1) {
        throw new NekostoreError_1.default('invalid-path', `${path} is not a path for collection`);
    }
    const [root, ...others] = paths;
    return chunk_1.default(others, 2).reduce((ref, [doc, col]) => ref.doc(doc).collection(col), driver.collection(root));
}
exports.getCollection = getCollection;
function getQuery(driver, path, descriptors) {
    return descriptors.reduce((ref, desc) => {
        switch (desc.type) {
            case 'endAt':
            case 'endBefore':
            case 'startAfter':
            case 'startAt':
                return ref[desc.type](desc.value);
            case 'limit':
                return ref.limit(desc.limit);
            case 'orderBy':
                return ref.orderBy(desc.field, desc.direction);
            case 'where':
                return ref.where(desc.field, desc.operator, desc.value);
            default:
                throw new NekostoreError_1.default('invalid-query', 
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                `${desc.type} is not valid query`);
        }
    }, driver.collection(path));
}
exports.getQuery = getQuery;
function getDoc(driver, path) {
    const paths = path.split(/\//g);
    if (paths.length % 2 !== 0) {
        throw new NekostoreError_1.default('invalid-path', `${path} is not a path for document`);
    }
    return driver
        .collection(paths.slice(0, -1).join('/'))
        .doc(paths.slice(-1)[0]);
}
exports.getDoc = getDoc;
//# sourceMappingURL=utilities.js.map